import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
  name: 'DaysDifference'
})
export class DaysDifference implements PipeTransform {

  transform(endDate): any {
    const endDateTime = new Date(endDate);
    const today = new Date();

    let diffDays: any =
      Math.ceil((endDateTime.getTime() - today.getTime()) / (24 * 60 * 60 * 1000));
    if (diffDays < 0) {
      if (diffDays === -1) {
        return diffDays = diffDays * (-1) + ' day ago';
      } else {
        return diffDays = diffDays * (-1) + ' days ago';
      }
    } else if (diffDays === 0) {
      return 'Today is last day';
    } else if (diffDays === 1) {
      return diffDays + ' day left';
    } else {
      return diffDays + ' days left';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/days-difference.pipe.ts